import { render } from "./CatSubCategoryEditModal.vue?vue&type=template&id=1d73c22a"
import script from "./CatSubCategoryEditModal.vue?vue&type=script&lang=js"
export * from "./CatSubCategoryEditModal.vue?vue&type=script&lang=js"

import "./CatSubCategoryEditModal.vue?vue&type=style&index=0&id=1d73c22a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__